<template>
  <div>
    <div class="page__bd">
      <div class="weui-cells__title">地址列表</div>
      <div class="weui-cells">
        <div class="weui-cell" v-for="item in addresses" :key="item._id">
          <div class="weui-cell__bd">
            <p>
              <span class="name">{{item.name}}</span>
              <span class="phone">{{item.phone}}</span>
            </p>
            <p>
              <span class="address">{{item.province.name}}{{item.city.name}}{{item.county.name}}{{item.detail}}</span>
            </p>
          </div>
          <div class="weui-cell__ft"></div>
          <div class="weui-cell__ft">
            <a class="weui-btn weui-btn_disabled weui-btn_default" href="javascript:" v-if="item.isDefault">删除</a>
            <a class="weui-btn weui-btn_warn" href="javascript:" v-if="!item.isDefault" @click="deleteAddress(item._id)">删除</a>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;">
      <div class="warehousing-footer-item go-jijian" style="flex:1" @click="goJijian">
        <a href="javascript:;">去寄件</a>
      </div>
      <div class="warehousing-footer-item go-my" style="flex:1" @click="goMy">
        <a href="javascript:;">去个人中心</a>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      addresses: []
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 获取地址列表
    // 获取用户常用地址列表
    axios
      .get("/api/address/wxlist")
      .then(response => {
        this.addresses = response.data.data;
      })
      .catch(error => {
        weui.topTips("获取重量费用类型列表失败", 2000);
      });
  },
  methods: {
    deleteAddress(_id) {
      let that = this;
      weui.confirm(
        "确定删除该地址？",
        function() {
          axios
            .delete("/api/address/wxdelete/" + _id)
            .then(res => {
              if (res.data.success) {
                weui.toast("删除成功", 1500);
                for (let i = 0; i < that.addresses.length; i++) {
                  if (_id == that.addresses[i]._id) {
                    that.addresses.splice(i, 1);
                    break;
                  }
                }
              } else {
                weui.alert("删除失败");
              }
            })
            .catch(err => {
              weui.alert("删除失败");
            });
        },
        function() {}
      );
    },
    goJijian() {
      this.$router.push("/expressTotakein/" + this.encodeToken);
    },
    goMy() {
      this.$router.push("/my/" + this.encodeToken);
    }
  }
};
</script>

<style scoped>
.name {
  font-size: 18px;
  font-weight: bold;
}
.address {
  font-size: 14px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.go-jijian {
  background-color: orangered;
}
.go-my {
  background-color: #1aad19;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/AddressManager.vue